import { useEffect } from 'react';
import { PageContainer } from '@/components';
import CreditButton from '@/components/common/CreditButton';
import DailySale from '@/components/reserve/DailySale/DailySale';
import { useDailySellManagement, useDevice } from '@/hooks';
import { useSelfContext } from '@/context';
import { envConfig } from '@/configs';
import { useAppStore } from '@/store';
import { useTranslation } from 'react-i18next';

export interface DailySellPageProps {
  variant: ComponentVariant;
}

export function DailySalePage({ variant }: DailySellPageProps) {

  const { findVariantById } = useSelfContext();

  const {
    dailySellPrograms,
    loading,
    error,
    buyModal,
    setBuyModal,
    buyDailySell,
    buyLoading,
    forgetModalVisible,
    setForgetModalVisible,
    getDailySellList,
  } = useDailySellManagement();

  const [t] = useTranslation(['reserve']);
  const { fetchCredit } = useAppStore();
  const { isDesktop } = useDevice();

  const items = dailySellPrograms.filter(x => findVariantById(Number(x.selfCode)) === variant);

  useEffect(() => {
    fetchCredit();
  }, [fetchCredit]);

  return (
    <PageContainer
      title={t(`reserve:context.daily-sale.${variant}`)}
      bodyClassName="lg:!px-16 lg:block flex flex-col items-center justify-center"
      endElement={!isDesktop() && !envConfig.ui.removeWallet ? <CreditButton /> : undefined}
    >
      <DailySale
        variant={variant}
        loading={loading}
        dailySellPrograms={items}
        errorMsg={error}
        onSelect={setBuyModal}
        setForgetModalVisible={setForgetModalVisible}
        buyModalVisible={buyModal}
        forgetModalVisible={forgetModalVisible}
        onPressBuy={(id, count) => buyDailySell(id, count)}
        buyLoading={buyLoading}
        getDailySellList={getDailySellList}
      />
    </PageContainer>
  );
}

export default DailySalePage;
